<!-- 155/573 ~ 25%-->
<div class="issues-line-graph" [style.width.px]="graphWidth" [style.height.px]="graphHeight">
    <canvas #graph width="{{graphWidth}}" height="{{graphHeight}}"></canvas>
</div>
<!-- <div class="issues-graph-legend" #graphLegend></div> -->